import { apiClient } from './api';
import {
  ChatRequest,
  ChatResponse
} from '../models/chat';

export class ChatService {
  // Since there's no specific chat endpoint, we'll use a generic completion endpoint
  // This can be updated when a proper chat endpoint is available
  static async sendMessage(request: ChatRequest): Promise<ChatResponse> {
    try {
      // Try to use a general chat endpoint if available
      const response = await apiClient.post('/api/chat/message', request);
      return response.data;
    } catch (error) {
      // Fallback to a generic endpoint or simulate response
      // In production, this should connect to the actual chat endpoint
      return {
        response: `I received your message: "${request.message}". However, the chat service is currently being configured. Please check back later or use one of the specialized agents for specific tasks.`,
        sessionId: request.sessionId || Date.now().toString(),
        timestamp: new Date().toISOString()
      };
    }
  }
}

export default ChatService;